
<modal
  size="full"
  :title="title"
  :open="open"
  @close="closeModal"
>
  <div>
    <div class="grid">
      <section>
        <image-upload
          v-if="showImageUpload"
          v-model="post.image"
          name="image"
          label="Upload an image for the post"
        />

        <text-input
          id="title"
          v-model.trim="post.title"
          label="Title"
          required
        />

        <text-input
          id="link"
          v-model.trim="post.link"
          type="url"
          label="Link"
        />

        <select-input
          id="category"
          v-model="post.category"
          label="Category"
          :options="postCategories"
          required
        />

        <text-area-input
          id="body"
          v-model="post.body"
          label="Body"
          required
        />
      </section>

      <section>
        <div
          v-for="(cardNote, i) in post.cardNotes"
          :key="i"
          class="card-note"
        >
          <div class="card-search-container">
            <div v-if="post.cardNotes[i].card" class="card-note-label">
              <align flex>
                <div><b>{{ post.cardNotes[i].cardLabel || post.cardNotes[i].card }}</b></div>
                <icon-button
                  class="remove"
                  icon="delete_outline"
                  @click="removeCardNote(i)"
                />
              </align>
            </div>

            <card-search
              v-else
              placeholder="Search for a card"
              @select="setCardNote(i, $event)"
            />
          </div>

          <div v-show="post.cardNotes[i].card" flex>
            <text-input
              v-model.trim="post.cardNotes[i].title"
              label="Title"
            />

            <text-area-input
              v-model="post.cardNotes[i].text"
              label="Notes"
            />
          </div>
        </div>

        <add-link @click="addCardNote">
          Add card note
        </add-link>
      </section>
    </div>
  </div>

  <template #footer>
    <btn :loading="saving" @click="submit">
      {{ buttonText }}
    </btn>
  </template>
</modal>
